import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import threadInfoFragment from '../../fragments/thread/threadInfo';

import { getThreadByIdQuery } from '../../queries/thread/getThread';

export const removeThreadReactionQuery = gql`
  mutation removeThreadReaction($input: RemoveThreadReactionInput!) {
    removeThreadReaction(input: $input) {
      ...threadInfo
    }
  }
  ${threadInfoFragment}
`;

const removeThreadReactionOptions = {
  props: ({ ownProps, mutate }) => ({
    removeThreadReaction: ({ input }) => {
      const fakeId = Math.round(Math.random() * -1000000);

      return mutate({
        variables: {
          input,
        },
        optimisticResponse: {
          __typename: 'Mutation',
          removeThreadReaction: {
            id: fakeId,
            threadId: input.threadId,
            type: 'like',
            __typename: 'ThreadReaction',
          },
        },
        update: (store, { data: { removeThreadReaction } }) => {
          const data = store.readQuery({
            query: getThreadByIdQuery,
            variables: {
              id: input.threadId,
            },
          });

          // ignore the server response and only update the cache with the
          // optimistic response
          if (typeof removeThreadReaction.id === 'string') return;

          data.thread.reactions.count--;
          data.thread.reactions.hasReacted = false;

          // Write our data back to the cache.
          store.writeQuery({
            query: getThreadByIdQuery,
            data,
            variables: {
              id: input.threadId,
            },
          });
        },
      });
    },
  }),
};

export default graphql(removeThreadReactionQuery, removeThreadReactionOptions);
